import { Arrow as o } from "./content/arrow/arrow.js";
import { Content as t } from "./content/content.js";
import { Provider as r } from "./provider.js";
import { Tooltip as i } from "./tooltip.js";
import { Trigger as p } from "./trigger.js";
const a = Object.assign(i, {
  Provider: r,
  Trigger: p,
  Content: Object.assign(t, {
    Arrow: o
  })
});
export {
  a as Tooltip,
  t as TooltipContent,
  o as TooltipContentArrow,
  r as TooltipProvider,
  p as TooltipTrigger
};
